export const API_V4 = 'apiV4';
export const VIEWPORT = {
  MOBILE: 'mobile',
  DESKTOP: 'desktop',
};
